DOMReady( function(){
  [... document.querySelectorAll('.content-event-place .tab')].map( tab => {
    tab.addEventListener('click', (e)=>{
      let idtab = tab.dataset.id;

      [... document.querySelectorAll('.content-event-place .tab')].map( tabactive => {
        if(tabactive.dataset.id == idtab)
        {
          tabactive.classList.add('active');
        }
        else{
          tabactive.classList.remove('active');
        }
      });


       if(idtab  == 'infos'){
         setTimeout(function () {
           window.dispatchEvent( new Event('resize') );
          }, 100);
       }

      [... document.querySelectorAll('.content-event-place .tab-info')].map( tabinfo => {
        if(tabinfo.getAttribute('id') == idtab)
        {
          tabinfo.style.display = 'block';

          let from = window.scrollY;
          let to = document.getElementById(idtab).getBoundingClientRect().top + from - (document.getElementById( 'header' ).offsetHeight) - 40;

          window.scrollTo(0, to);
        }
        else{
          tabinfo.style.display = 'none';
        }
      });

    });

  });


  [... document.querySelectorAll('.link-comments,.link-form-comments')].map( link => {
    link.addEventListener('click' ,( e ) => {
    {
      e.preventDefault();
      [... document.querySelectorAll('.content-event-place .tab')].map( tab => {
        let idtab = tab.dataset.id;
        if(idtab == 'note'){
          tab.classList.add('active');
        }
        else{
          tab.classList.remove('active');
        }

      });

      [... document.querySelectorAll('.content-event-place .tab-info')].map( tabinfo => {
        if(tabinfo.getAttribute('id') == 'note')
        {
          tabinfo.style.display = 'block';
        }
        else{
          tabinfo.style.display = 'none';
        }
      });

    }
    });
  });

  [... document.querySelectorAll('.type-place .notation-content span','.type-event .notation-content span')].map( linkComment => {
    linkComment.addEventListener('click', (e)=>{
      let idtab = 'note';

      [... document.querySelectorAll('.content-event-place .tab')].map( tabactive => {
        if(tabactive.dataset.id == idtab)
        {
          tabactive.classList.add('active');
        }
        else{
          tabactive.classList.remove('active');
        }
      });


      [... document.querySelectorAll('.content-event-place .tab-info')].map( tabinfo => {
        if(tabinfo.getAttribute('id') == idtab)
        {
          tabinfo.style.display = 'block';

          let from = window.scrollY;
          let target = "comment-answer";

          if(linkComment.classList.contains('link-comments')){
            target="listcomments";
          }

          let to = document.getElementById(target).getBoundingClientRect().top + from - (document.getElementById( 'header' ).offsetHeight) - 40;

          window.scrollTo(0, to);
        }
        else{
          tabinfo.style.display = 'none';
        }
      });

    });

  });
});
